// TWO user-facing modes (UI/UX audit Phase 3): a trade either risks real money (LIVE) or it does not
// (SIMULATED). The engine keeps its precise environments - PAPER (paper fills on Zerodha prices), SHADOW
// (a real order Zerodha is expected to reject, then a simulated fill) and SIMULATION (the admin mock broker) -
// and they stay visible as the smaller second word, never as the headline.

export const LIVE = "LIVE";
export const SIMULATED = "SIMULATED";

const DETAIL = {
  LIVE: "LIVE — real orders at Zerodha, real money",
  SHADOW: "SIMULATED (shadow) — Zerodha receives the order and rejects it by design; the fill is simulated. No real money.",
  PAPER: "SIMULATED (paper) — paper fills on live Zerodha prices. No real money.",
  SIMULATION: "SIMULATED (mock) — the admin mock broker and mock prices. No real money.",
};

export const isLive = (env) => String(env || "").toUpperCase() === LIVE;

/** The headline word for an environment: LIVE or SIMULATED (null for an unknown / missing one). */
export function modeText(env) {
  const e = String(env || "").toUpperCase();
  if (!e || e === "NOT_ENABLED") return null;
  return e === LIVE ? LIVE : SIMULATED;
}

/** The second, smaller word: "shadow" | "paper" | "mock" (none for LIVE). */
export function modeSub(env) {
  return { SHADOW: "shadow", PAPER: "paper", SIMULATION: "mock" }[String(env || "").toUpperCase()] || null;
}

/** "SIMULATED · shadow" / "LIVE": one line where a tag fits. */
export function modeLabel(env) {
  const t = modeText(env);
  if (!t) return env || "—";
  const s = modeSub(env);
  return s ? `${t} · ${s}` : t;
}

export function modeTitle(env) {
  return DETAIL[String(env || "").toUpperCase()] || "";
}

export const MODE_CLASS = {
  LIVE: "bg-[#FF3B30]/20 text-[#FF6b62] border-[#FF3B30]/40",
  SIMULATED: "bg-[#7c3aed]/15 text-[#c4b5fd] border-[#7c3aed]/40",
};

/** The account chip: LIVE if ANY product of the account trades live, else SIMULATED, with each product named.
 *  summary = /account/summary: {mode (futures), options_mode, products}. */
export function accountMode(summary) {
  const products = summary?.products;
  const parts = [];
  if (products !== "OPTIONS_ONLY" && summary?.mode) parts.push(["Futures", summary.mode]);
  if (products !== "FUTURES_ONLY" && summary?.options_mode) parts.push(["Options", summary.options_mode]);
  if (products === "OPTIONS_ONLY" && !summary?.options_mode && summary?.mode) parts.push(["Options", summary.mode]);
  const live = parts.some(([, m]) => isLive(m));
  const enabled = parts.filter(([, m]) => modeText(m));
  return {
    text: !enabled.length ? "NOT ENABLED" : live ? LIVE : SIMULATED,
    live,
    detail: parts.map(([p, m]) => `${p}: ${modeText(m) ? modeLabel(m) : "not enabled"}`).join(" · "),
    title: parts.map(([p, m]) => `${p} — ${modeTitle(m) || "not enabled"}`).join("\n"),
  };
}
